import React from 'react'
import { useTranslation } from 'react-i18next'
import { SessionClip } from './SessionVideo'

/**
 * What Pro adds, told rather than tabulated: the two daily corrections, then the calls with a
 * teacher next to a real session. Every line describes what happens today (see PlanCompare for
 * the sources).
 */
const ProDetails = () => {
  const { t } = useTranslation('plan')
  return (
    <section className='plan-pro' aria-labelledby='plan-pro-title'>
      <h2 className='plan-section-title' id='plan-pro-title'>
        {t('pro.title')}
      </h2>
      <p className='plan-pro-lead'>{t('pro.lead')}</p>

      <div className='plan-pro-grid'>
        <div className='plan-pro-text'>
          <h3 className='plan-pro-title'>{t('pro.writing.title')}</h3>
          <p>{t('pro.writing.body')}</p>
          <p>{t('pro.writing.turnaround')}</p>
        </div>

        <div className='plan-pro-text'>
          <h3 className='plan-pro-title'>{t('pro.speaking.title')}</h3>
          <p>{t('pro.speaking.body')}</p>
          <p>{t('pro.speaking.oneCorrection')}</p>
        </div>
      </div>

      <div className='plan-pro-block'>
        <figure className='plan-pro-figure'>
          <SessionClip />
          <figcaption>{t('pro.sessionCaption')}</figcaption>
        </figure>
        <div className='plan-pro-text'>
          <h3 className='plan-pro-title'>{t('pro.calls.title')}</h3>
          <dl className='plan-pro-calls'>
            <dt>{t('pro.calls.welcomeTitle')}</dt>
            <dd>{t('pro.calls.welcomeBody')}</dd>
            <dt>{t('pro.calls.reviewTitle')}</dt>
            <dd>{t('pro.calls.reviewBody')}</dd>
          </dl>
          {/* Said before purchase: the calls and corrections are in Chinese or English. */}
          <p>{t('common:teacherLanguageNotice')}</p>
        </div>
      </div>
    </section>
  )
}

export default ProDetails
